import React, {Component} from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {Backdrop, Block, Divider, Overlay, Portal} from "reakit";
import {Box, Card, Flex, Heading, Image, Text} from 'rebass';

import chevronRight from '../../resources/img/icons/Chevron_2@1x.png'

import IosArrowBack from 'react-ionicons/lib/IosArrowBack'
import check from "../../resources/img/icons/Checkbox@1x-black.png";

const HeaderWrapper = styled(Card)`
	position: relative;
	top: 0;
	left: 0;
	width: 100vw;
	max-height: 113px;
`;

const StyledHeader = styled(Heading)`
	margin-top: 2px;
`;

const FilterOverlay = styled(Overlay)`
	@media(max-width: 700px){
		width: 100% !important;
		height: 100% !important;
	}
`;

class Types extends Component {

	state = {
		selected: null
	};

	componentDidMount() {
		const {types, defaultValue} = this.props;
		let selected = [];
		if (defaultValue !== null) {
			selected = types.filter(type => type.id === defaultValue);
			if (selected.length === 1) {
				this.setState({selected: selected[0]})
			}
		}
	}

	handleSelect = (selected) => {
		// const {handleSelect} = this.props;
		this.setState({selected:selected})
		console.log('select')
	};

	render() {
		const {selected} = this.state;
		const {types, defaultValue, handleSelect, value, height, width, newLeave} = this.props;

		return (
			<Overlay.Container>
				{overlay => (
					<Block width={'100%'}>
						<Flex flexWrap={'wrap'} width={1} onClick={overlay.show} {...overlay} px={newLeave ? 3 : 0}>
							<Box pl={'7px'}>
								<Text py={3} fontSize={'16px'} fontWeight={600}>Leave Type</Text>
							</Box>
							<Box mr={'auto'}/><Box><Text fontWeight={600} py={3} color={'meta'}>{selected && selected.name}</Text></Box>
							<Box pl={3}>
								<Text py={3} color='metaText'><Image src={chevronRight}/> </Text>
							</Box>
						</Flex>
						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
						<FilterOverlay use={Portal} {...overlay} margin={0} padding={0} overflow={'auto'} height={height || '65%'} width={width || "65%"}>
							<HeaderWrapper boxShadow={'main'} width={'100% !important'} p={2}>
								<Box ml={0} mt={2} height={'30px'} width={'30px'}>
								<IosArrowBack fontSize={'30px'} onClick={overlay.hide}/>
								</Box>
								<StyledHeader pl={"6px"} pt={2} pb={0} mb={0} fontWeight={700}>Leave Type</StyledHeader>
							</HeaderWrapper>
							<Block>

								<Block height={'100%'}>
									<Flex flexDirection={'column'} p={1} mt={3}>
										{types !== "" && (
											types.map(type => (
												type.activated?
												<Box  key={type.id} width={1} onClick={() => {
													this.setState({selected: type});
													handleSelect(defaultValue === null ? 'type' : 'leave_type', type.id);

													overlay.hide()
												}}>
													<Flex>
														<Box>
													<Text pl={'7px'} fontWeight={600} py={3}>{type.name}</Text>
														</Box>
														<Box ml={'auto'}/>
														<Box ml={'auto'}/>
														<Box pt={3} pr={2}>
															{value === type.id && <Image src={check}/>}
														</Box>
													</Flex>
													<Box width={1}><Divider margin={0} padding={0}/></Box>

												</Box>
											:""
											))
										)}

									</Flex>

								</Block>
							</Block>
						</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}
}

Types.propTypes = {
	defaultValue: PropTypes.string
};

Types.defaultProps = {
	defaultValue: null
};


export default Types
